$(document).ready(function () {
  // таб
  $(".custom-tab__head").click(function () {
    const customTab = $(this).parents(".custom-tab");
    customTab.toggleClass("custom-tab--active");
    const customTabBody = $(this).siblings(".custom-tab__body");
    customTabBody.slideToggle();
  });

  const customSectionNavPhantom = $(".custom__section__nav__phantom");
  if (customSectionNavPhantom.length) {
    const customSectionNav = customSectionNavPhantom.find(
      ".custom__section__nav "
    );
    customSectionNavPhantom.css("min-height", customSectionNav.height());
  }
});
